import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

class Log extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        record: {},
    }

    loadData = () => {
        const { record } = this.state;
        const { customerCompanyId } = record;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryCustomerCompanyLog, {
            customerCompanyId,
        }).then(res => {
            const { data } = res;
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record, type) => {
        this.setState({
            type,
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => {
        const columns = [{
            title: '交接人',
            dataIndex: 'user',
            key: 'user',
            width: 120,
            render: (text, record) => {
                const { userCompellation, employeeCode } = record;
                return format('joint', userCompellation, employeeCode);
            }
        }, {
            title: '接收人',
            dataIndex: 'handoverUser',
            key: 'handoverUser',
            width: 120,
            render: (text, record) => {
                const { handoverUserCompellation, handoverEmployeeCode } = record;
                return format('joint', handoverUserCompellation, handoverEmployeeCode);
            }
        }, {
            title: '交接时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 130,
        }, {
            title: '操作人',
            dataIndex: 'createUser',
            key: 'createUser',
            width: 120,
            render: (text, record) => {
                const { createUserCompellation, createEmployeeCode } = record;
                return format('joint', createUserCompellation, createEmployeeCode);
            }
        }];
        return columns;
    }

    getContent = () => {
        const { data } = this.state;
        return (
            <div style={{ minHeight: 100 }}>
                {
                    (data || []).length > 0 ?
                        data.map(item => {
                            const { customerCompanyBaHandoverLogId, detailList } = item;
                            return (
                                <div key={customerCompanyBaHandoverLogId} style={{marginBottom: 10}}>
                                    <TableC
                                        data={detailList}
                                        columns={this.getColumns()}
                                    />
                                </div>
                            );
                        })
                    :
                        <div style={{ lineHeight: '100px', textAlign: 'center' }}>暂无交接</div>
                }
            </div>
        );
    }

    render() {
        const { visible, record, loading } = this.state;
        const { customerCompanyName, customerCompanyCode } = record;
        return (
            <Modal
                title="交接日志"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width={800}
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
               <Spin spinning={loading}>
                    <div>
                        <p style={{ marginBottom: 10 }}>
                            <span style={{ paddingRight: 16 }}>客户名称:</span>
                            {customerCompanyName}
                        </p>
                        <p style={{ marginBottom: 10 }}>
                            <span style={{ paddingRight: 16 }}>客户代码:</span>
                            {customerCompanyCode}
                        </p>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Log;


// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/Log.js